'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _IyvListFilters = require('./IyvListFilters.css');

var _IyvListFilters2 = _interopRequireDefault(_IyvListFilters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IyvListSearchSettingsButton = (_dec = (0, _reactCssModules2.default)(_IyvListFilters2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(IyvListSearchSettingsButton, _Component);

  //
  function IyvListSearchSettingsButton(props) {
    (0, _classCallCheck3.default)(this, IyvListSearchSettingsButton);
    return (0, _possibleConstructorReturn3.default)(this, (IyvListSearchSettingsButton.__proto__ || (0, _getPrototypeOf2.default)(IyvListSearchSettingsButton)).call(this, props));
  }
  //


  (0, _createClass3.default)(IyvListSearchSettingsButton, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          styleName: this.props.currentTutorial === 2 && this.props.showTutorial ? 'settings-wrap tutorial-highlight-filters-wrap' : 'settings-wrap',
          onClick: this.props.clickCloseTutorial
        },
        _react2.default.createElement(
          'button',
          {
            styleName: 'adjust-filters',
            onClick: this.props.clickToggleFilters,
            role: 'button',
            tabIndex: '0',
            title: 'Adjust filters'
          },
          _react2.default.createElement(
            'span',
            { styleName: 'adjust-filters-text' },
            _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-sliders' }),
            '\xA0 Search settings',
            _react2.default.createElement(_components.LinkIcon, {
              faclass: this.props.showFilters ? 'fa-angle-up' : 'fa-angle-down'
            })
          )
        ),
        _react2.default.createElement(
          _components.Link,
          {
            to: _config2.default.routes.howitworks + '#spreadsheet',
            title: 'Download spreadsheet',
            xstrong: true
          },
          'Download spreadsheet',
          _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-download' }),
          _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-file-excel-o' })
        )
      );
    }
  }]);
  return IyvListSearchSettingsButton;
}(_react.Component), _class2.propTypes = {
  currentTutorial: _react.PropTypes.number,
  showTutorial: _react.PropTypes.bool,
  clickCloseTutorial: _react.PropTypes.func,
  clickToggleFilters: _react.PropTypes.func,
  showFilters: _react.PropTypes.bool
}, _temp)) || _class);
exports.default = IyvListSearchSettingsButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/IyvListFilters/IyvListSearchSettingsButton.js
// module id = 1367
// module chunks = 0